import { render, staticRenderFns } from "./bbLocalImgComponent.vue?vue&type=template&id=23d0d7aa&"
import script from "./bbLocalImgComponent.vue?vue&type=script&lang=js&"
export * from "./bbLocalImgComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports